import { Zone } from './../_models/zone';
import { City } from "./../_models/city";
import { State } from "./../_models/state";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from "./auth.service";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Courier } from "../_models/courier.js";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ZoneService {
  constructor(private http: HttpClient, public auth: AuthService) {}

  public getZones() {
    const token = localStorage.getItem("prime-token");
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.zones}/`;
    return this.http.get<Zone[]>(requestUrl, options);
  }

  public getZone(zoneId: number) {
    const token = localStorage.getItem("prime-token");
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.zones}/${zoneId}`;
    return this.http.get<Zone>(requestUrl, options);
  }

  public addZone(zone: Zone) {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.zones}/`;
    console.log(requestUrl);
    return this.http.post<Zone>(requestUrl, zone, options);
  }

  public updateZone(zone: Zone) {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.zones}/${zone.id}`;
    console.log(requestUrl);
    return this.http.put<Zone>(requestUrl, zone, options);
  }

  public deleteZone(zoneId: number) {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.zones}/${zoneId}`;
    console.log(requestUrl);
    return this.http.delete(requestUrl, options);
  }
}
